import { Button } from '../../../../common/_custom';
import RefreshIcon from '../../../../assets/Svg/RefreshIcon';
import TalkToUsModal from '../../../../common/UnlockRefresh/TalkToUsModal';
import { UNLOCK_REFRESH_LABEL } from '../../../../common/UnlockRefresh/constants';
import { useMobileRefreshButtonLogic } from './useMobileRefreshButtonLogic';
import styles from './MobileRefreshButton.module.scss';

const MobileRefreshButton = () => {
    const { shouldDisableUnlock, isFetching, iconColour, onClick, isTalkToUsOpen, closeTalkToUs, contactInput } =
        useMobileRefreshButtonLogic();

    return (
        <>
            <Button
                type="button"
                text=""
                aria-label={UNLOCK_REFRESH_LABEL}
                icon={<RefreshIcon colour={iconColour} />}
                loading={isFetching}
                disabled={shouldDisableUnlock || isFetching}
                className={styles.RefreshButton}
                onClick={onClick}
            />
            <TalkToUsModal isOpen={isTalkToUsOpen} onClose={closeTalkToUs} contactInput={contactInput} />
        </>
    );
};

export default MobileRefreshButton;
